import { List } from 'antd'
import { BreakDataListProps } from './types'
import { useConcreteTestSetTrackerContext } from '../../../../ConcreteTestSetTrackerContext'
import { useMemo } from 'react'

/**
 * Renders break-data records as a compact, sorted list within a tracker table
 * cell. Missing values display as `N/A` so a record remains visible while its
 * break result is unavailable.
 */
function BreakDataList<T>({
  dataSource,
  renderItem,
  sort,
}: BreakDataListProps<T>) {
  const { relations } = useConcreteTestSetTrackerContext()
  const sorted = useMemo(() => [...dataSource].sort(sort), [dataSource, sort])
  if (!dataSource.length) return null
  return (
    <List
      dataSource={sorted}
      split={false}
      size="small"
      loading={{
        spinning: relations.loading,
        // Prevent column spinners from overlapping row actions
        style: { zIndex: 1 },
      }}
      renderItem={(record) => {
        const { label, value } = renderItem(record)
        return (
          <List.Item style={{ padding: '8px 0' }}>
            {label} : {value?.toLocaleString() ?? 'N/A'}
          </List.Item>
        )
      }}
    />
  )
}

export default BreakDataList
